if (!customElements.get('pf-brand-marquee')) {
  customElements.define('pf-brand-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.classList.add('is-moving');
      const viewport = this.querySelector('.pf-brand-viewport');
      const toggle = () => { this.dataset.paused = String(this.dataset.paused !== 'true'); };
      viewport?.addEventListener('click', event => { if (!event.target.closest('a')) toggle(); }, { signal: this.controller.signal });
      viewport?.addEventListener('keydown', event => {
        if (event.key !== ' ' || event.target.closest('a')) return;
        event.preventDefault();
        toggle();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
